import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { pipe } from 'ramda';

import { TextInput, Dropdown, DatePicker } from 'components';
import { formatDateString, parseDateString } from 'utils/formatString';
import { EMAIL_REGEXP } from 'constants/common';

import { validateAge } from 'utils/validateAge';
import { FIELD_TYPES, TEXT_TYPES } from '../constants';

class FormGroupFieldSwitcher extends PureComponent {
  validate = (value) => {
    const {
      mask,
      textType,
      required,
      label,
      regExp,
    } = this.props;

    let error = null;

    if (value) {
      if (mask && mask.length > value.length) {
        error = 'settings.userForm.errors.invalidPhoneNumber';
      } else if (regExp && !RegExp(regExp).test(value)) {
        error = 'settings.userForm.errors.invalidStringFormat';
      } else if (label === 'Дата рождения' && !validateAge(value)) {
        error = 'settings.userForm.errors.invalidDateOfBirth';
      } else if (textType === TEXT_TYPES.EMAIL && !value.match(EMAIL_REGEXP)) {
        error = 'settings.userForm.errors.invalidEmail';
      }
    } else if (required) {
      error = 'settings.userForm.errors.required';
    }

    return {
      value,
      error,
    };
  };

  render() {
    const {
      type,
      value,
      options,
      onChange,
      mask,
      maxLength,
      apiDateFormat,
    } = this.props;

    switch (type) {
      case FIELD_TYPES.DATEPICKER:
        return (
          <DatePicker
            value={value ? parseDateString(value) : null}
            onChange={pipe(
              (date) => (date ? formatDateString(date, apiDateFormat) : ''),
              this.validate,
              onChange,
            )}
            onBlur={pipe(
              (date) => (date ? formatDateString(date, apiDateFormat) : ''),
              this.validate,
              onChange,
            )}
          />
        );
      case FIELD_TYPES.SELECT:
        // Due to USSS bug — there are some selects without options
        return options ? (
          <Dropdown
            value={value}
            options={options}
            wide
            onChange={pipe(
              this.validate,
              onChange,
            )}
            onBlur={pipe(
              this.validate,
              onChange,
            )}
          />
        ) : (
          <TextInput
            value={value}
            mask={mask}
            maxLength={`${maxLength}`}
            onChange={pipe(
              this.validate,
              onChange,
            )}
            onBlur={pipe(
              this.validate,
              onChange,
            )}
          />
        );
      case FIELD_TYPES.INPUT:
        return (
          <TextInput
            value={value}
            mask={mask}
            maxLength={`${maxLength}`}
            onChange={pipe(
              this.validate,
              onChange,
            )}
            onBlur={pipe(
              this.validate,
              onChange,
            )}
          />
        );
      default:
        return null;
    }
  }
}

FormGroupFieldSwitcher.defaultProps = {
  value: '',
};

FormGroupFieldSwitcher.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  label: PropTypes.string,
  regExp: PropTypes.string,
  options: PropTypes.array,
  onChange: PropTypes.func,
  type: PropTypes.string,
  mask: PropTypes.string,
  maxLength: PropTypes.number,
  textType: PropTypes.string,
  required: PropTypes.bool,
  apiDateFormat: PropTypes.string,
};

export default FormGroupFieldSwitcher;
